function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefa41"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefa41"] = parcelRequire;
}
parcelRequire.register("16ViG", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0cf2cca98fe94ea2$export$6503ec6e8aabbaf; }, function (v) { return $0cf2cca98fe94ea2$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0cf2cca98fe94ea2$export$f7ad0328861e2f03; }, function (v) { return $0cf2cca98fe94ea2$export$f7ad0328861e2f03 = v; });
var $0cf2cca98fe94ea2$export$6503ec6e8aabbaf;
var $0cf2cca98fe94ea2$export$f7ad0328861e2f03;
"use strict";
var $0cf2cca98fe94ea2$var$mapping = {};
function $0cf2cca98fe94ea2$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0cf2cca98fe94ea2$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0cf2cca98fe94ea2$var$resolve(id) {
    var resolved = $0cf2cca98fe94ea2$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0cf2cca98fe94ea2$export$6503ec6e8aabbaf = $0cf2cca98fe94ea2$var$register;
$0cf2cca98fe94ea2$export$f7ad0328861e2f03 = $0cf2cca98fe94ea2$var$resolve;

});

var $ec186a6cb47635a7$exports = {};

(parcelRequire("16ViG")).register(JSON.parse('{"02f4U":"index.066e6fe0.js","k5fzK":"presence-worker.4c95b876.js","aMeZU":"audio_alert.642b8b15.wav","8pDC6":"agent-profile-large-invite.85ec4996.svg","3Cxfo":"Logo_purple_transparent_BG.57bf17bd.png","bd2Cq":"index.680edb41.css"}'));


//# sourceMappingURL=index.3e5794a7.js.map
